import Guid from '~/helpers/guid'

export default {
  computed: {
    dropdownControlId(): string {
      return Guid.create()
    },
  },
}